import checkRegion from '../section/policy/checkRegion'

const header = () => {
  const body = document.getElementsByTagName('body')[0]
  const headerElement = document.getElementsByTagName('header')[0]
  const burger = document.getElementById('burger')
  const quizBtn = document.getElementById('quiz-btn')
  const menu = document.getElementById('mobile-menu')
  const menuLinks = document.querySelectorAll('.header__menu')

  const screenWidth = document.documentElement.clientWidth

  burger.addEventListener('click', () => {
    body.classList.toggle('no-scroll')
    burger.classList.toggle('active')
    menu.classList.toggle('active')
    headerElement.classList.toggle('active')
    quizBtn.classList.toggle('hidden')
    menuLinks.forEach(link => link.classList.remove('active'))
  }, false)

  if (screenWidth < 900) {
    const parentSubMenu = menu.querySelectorAll('.menu-item-has-children')
    if (parentSubMenu) {
      parentSubMenu.forEach((thisParentSubMenu) => {
        thisParentSubMenu.addEventListener('click', () => {
          thisParentSubMenu.classList.toggle('active')
        })
      })
    }
  }

  if (screenWidth < 900) {
    const menuItem = menu.querySelectorAll('.menu-item')
    if (menuItem) {
      menuItem.forEach((thisMenuItem) => {
        thisMenuItem.addEventListener('click', () => {
          if (!thisMenuItem.classList.contains('menu-item-has-children')) {
            body.classList.toggle('no-scroll')
            burger.classList.toggle('active')
            menu.classList.toggle('active')
          }
        })
      })
    }
  }

  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 1) {
      headerElement.classList.add('sticky')
    } else {
      headerElement.classList.remove('sticky')
    }
  })

  checkRegion()
}

export default header
